import type { FC } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getOwnerReportPreview,
  QUERY_OWNER_REPORT_PREVIEW
} from "api/owner-report-shares";
import { ReportPreview } from "views/owner-screening-report/components/ReportPreview";

/**
 * What a recipient would see if this application were shared right now, built
 * through the same builder a real share uses. Nothing is created and nothing is
 * sent, so a partner can look as often as they like.
 */
export const PreviewModal: FC<{
  opened: boolean;
  onClose: () => void;
  applicationId: string | number;
  /** What the sender has typed so far — previewed exactly as it will be sent. */
  message?: string;
}> = ({ opened, onClose, applicationId, message }) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QUERY_OWNER_REPORT_PREVIEW(applicationId),
    queryFn: () => getOwnerReportPreview(applicationId),
    enabled: opened
  });

  return (
    <ReportPreview
      opened={opened}
      onClose={onClose}
      report={data?.report}
      isLoading={isLoading}
      isError={isError}
      excludedPeople={data?.excluded_people}
      message={message?.trim() ? message : null}
    />
  );
};
